import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { fetchPageData } from "../endpoint/pageApi";
import { baseUrl } from "../utils/base_url";
import { Link, useNavigate } from "react-router-dom";
import Marquee from "react-fast-marquee";
import NewsCard from "../components/NewsCard/NewsCard";

const NewsCards = ({ data }) => {
  const navigate = useNavigate();

  const openNews = (slug) => {
    navigate(`/news/${slug}`);
  };
  return (
    <div
      onClick={() => openNews(data?.slug)}
      className="col-sm-12 col-md-6 col-lg-4 mb-4 text-decoration-none cursor-pointer"
    >
      <NewsCard
        topIcon={data?.image?.url}
        topHeading={data?.title}
        text={data?.subtitle}
      />
    </div>
  );
};

const PartnerSection = ({ data }) => {
  return (
    <div className="py-5 text-center">
      {data?.heading && (
        <h2 className="display-5 fw-semibold text-white mb-4">
          {data.heading}
        </h2>
      )}

      <Marquee
        gradient={false}
        speed={50}
        pauseOnHover={false}
        autoFill={true}
        play={true}
        loop={0}
      >
        {(data?.partner_logos?.length
          ? [...data.partner_logos, ...data.partner_logos]
          : []
        ).map((img, idx) => (
          <div
            key={idx}
            className="d-flex align-items-center justify-content-center mx-4"
            style={{
              width: "140px",
              height: "80px",
              flexShrink: 0,
            }}
          >
            <img
              src={`${baseUrl}${img.url}`}
              alt="Partner Logo"
              className="img-fluid"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                filter: "brightness(0) invert(1)",
                transition: "filter 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.filter = "")}
              onMouseLeave={(e) =>
                (e.currentTarget.style.filter = "brightness(0) invert(1)")
              }
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
};

const CustomerSection = ({ data }) => {
  return (
    <div className="py-5 text-center">
      {data?.heading && (
        <h2 className="display-5 fw-semibold text-white mb-4">
          {data.heading}
        </h2>
      )}
      <div className="customer-grid">
        {data?.customer_logos?.map((img, idx) => (
          <div key={idx} className="customer-box">
            <img
              src={`${baseUrl}${img?.url}`}
              alt="Customer Logo"
              className="customer-logo"
              style={{
                width: "100px",
                height: "auto",
                filter: "brightness(0) invert(1)",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

const NewsandInsight = () => {
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);
  const [newsData, setNewsData] = useState([]);
  const [pagination, setPagination] = useState();

  useEffect(() => {
    fetchPageData(
      "pages?filters[slug][$eq]=news-insight",
      setPageData,
      setLoader
    );
  }, []);
  useEffect(() => {
    fetchPageData(
      "news?populate=*",
      setNewsData,
      setLoader,
      true,
      false,
      setPagination,
      true
    );
  }, []);

  useEffect(() => {
    console.log(newsData);
  }, [newsData]);

  return (
    <>
      <MainLayout loader={loader}>
        <div
          className="container-fluid  p-0 overflow-x-hidden"
          style={{
            background: "#090D24",
          }}
        >
          <div className="row p-5 gap-5">
            <div className="col-12 text-center ">
              <span className="display-4 font-bold text-white">
                News and Insight
              </span>
            </div>
            <div className="col-12">
              <div className="row gx-4">
                {newsData?.newsCard?.map((data, idx) => (
                  <NewsCards key={idx} data={data} />
                ))}
              </div>
            </div>
            <div className="col-12">
              <PartnerSection data={pageData?.partners} />
            </div>
            <div className="col-12">
              <CustomerSection data={pageData?.cutomers} />
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default NewsandInsight;
